import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]" data-testid="auth-loading">
        <div className="h-10 w-10 rounded-full border-4 border-[#5B4199]/20 border-t-[#5B4199] animate-spin" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/studio/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
